export default "__VITE_ASSET__C0_vItFz__"